exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-info .form-row.col .form-label{width:130px}.form-info .form-row.col .form-value{width:calc(100% - 130px - 20px);width:-moz-calc(100% - 130px - 20px);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-521e21b6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/tradeVoucher/TradeDetail.vue
// module id = 2804
// module chunks = 0